import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import "../../my_styles/myStyles.css";

import logo from "./assets/logo.png";

//
const Menu = () => {
  const menuStyle = {
    color: "white",
    fontSize: "22px",
    fontWeight: "bolder",
    borderRadius: "2px",
    padding: "8px 16px",
    margin: "0 10px", // Space between menu links
  };

  return (
    <></>
    // <Navbar expand="lg" style={{ backgroundColor: "rgba(0, 0, 0, 0.7)" }}>
    //   <Container>
    //     <Navbar.Brand href="#home">
    //       <img
    //         src={logo}
    //         width="130"
    //         height="70"
    //         className="d-inline-block align-top"
    //         alt="React Bootstrap logo"
    //       />
    //     </Navbar.Brand>
    //     <Navbar.Toggle aria-controls="basic-navbar-nav" />
    //     <Navbar.Collapse id="basic-navbar-nav" className="bg-lignt">
    //       <Nav className="me-auto">
    //         <Nav.Link href="#home" style={menuStyle}>
    //           Home
    //         </Nav.Link>
    //         <Nav.Link href="#link" style={menuStyle}>
    //           Link
    //         </Nav.Link>
    //       </Nav>
    //     </Navbar.Collapse>
    //   </Container>
    // </Navbar>
  );
};

export default Menu;
